import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/919136262913?text=Hi%20RoleIQ%20Team%2C%20I%20would%20like%20to%20know%20more%20about%20your%20platform."
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform group"
      data-testid="whatsapp-button"
    >
      <MessageCircle className="w-7 h-7 text-white" />
      <span className="absolute right-16 bg-navy text-white font-dm text-xs px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chat with us on WhatsApp
      </span>
    </a>
  );
}
